import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Typography from '@material-ui/core/Typography';
import { addCustomerPropertyMultiple } from '../Networking/APIClient';

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 20,
};

const editTextStyle = {
    width: '100%'
}

// This should have no margin to the element above
const firstNameTextStyle = {
    marginTop: 0,
    width: '100%'
}

const selectStyle = {
    textAlign: 'left',
    marginTop: 16,
    marginBottom: 0,
    paddingBottom: 0,
    width: '100%'
}

let self;
let t;

class SignUpStep2 extends Component {
    constructor(props) {
        super(props);

        self = this;
        t = props.t;

        const customer = this.props.customerData;

        this.state = {
            location_installed: {
                intValue: this.getIntValueForLocationInstalledText(customer.location_installed),
                textValue: customer.location_installed,
                key: customer.location_installed,
                error: false,
                helperText: '',
                required: true
            },
            first_name: {
                value: customer.first_name,
                error: false,
                helperText: '',
                required: false
            },
            last_name: {
                value: customer.last_name,
                error: false,
                helperText: '',
                required: false
            },
            mobile_phone: {
                value: customer.mobile_phone,
                error: false,
                helperText: '+xx yyy yy yyy',
                required: false
            },
            address_1: {
                value: customer.address_1,
                error: false,
                helperText: '',
                required: false
            },
            address_2: {
                value: customer.address_2,
                error: false,
                helperText: '',
                required: false
            },
            postal_code: {
                value: customer.postal_code,
                error: false,
                helperText: '',
                required: false
            },
            city: {
                value: customer.city,
                error: false,
                helperText: '',
                required: false
            },
            country: {
                value: customer.country,
                error: false,
                helperText: '',
                required: false
            },
            organization_name: {
                value: customer.organization_name,
                error: false,
                helperText: t('company_customers_only'),
                required: false
            },
        }
    }

    getIntValueForLocationInstalledText(location_installed) {
        switch (location_installed) {
            case 'not_selected':
                return 0;
            case 'primary_home':
                return 1;
            case 'secondary_home':
                return 2;
            case 'multiple_locations':
                return 3;
            default:
                return 0;
        }
    }

    onFinishClicked = e => {
        e.preventDefault();

        // The user should now be able to use the menu again
        if (self.props.setMenuIsClickable != null) {
            self.props.setMenuIsClickable(true);
        }

        const onOk = function onOk() {
            // Todo: progress bar
            console.log("Set multiple ok!");
            self.props.openFinalFeedbackDialog(true);
        };

        const onError = function onError() {
            // Todo: progress bar
            console.log("Set multiple failed");
            self.props.openFinalFeedbackDialog(false);
        };

        addCustomerPropertyMultiple(
            self.props.usingValueCode,
            self.props.credentials,
            self.state.first_name.value,
            self.state.last_name.value,
            self.state.mobile_phone.value,
            " ", //dealer_name is not part of the view
            self.state.address_1.value,
            self.state.address_2.value,
            self.state.postal_code.value,
            self.state.city.value,
            self.state.country.value,
            self.state.organization_name.value,
            self.state.location_installed.key,
            onOk,
            onError
        );
    }

    handleChange = name => event => {
        this.setState({
            ...this.state,
            [name]: {
                ...this.state[name],
                value: event.target.value
            }
        });
    };

    // This method is needed so that the soft keyboard of phones closes
    // when the "submit" button of the soft keyboard is clicked
    // on the last text field
    onKeyPressed = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            document.activeElement.blur();
        }
    }

    handleSelectChange(e) {
        let textValue = '';
        let key = '';
        switch (e.target.value) {
            case 0:
                key = 'None'
                textValue = t('not_selected');
                break;
            case 1:
                key = 'primary_home'
                textValue = t(key);
                break;
            case 2:
                key = 'secondary_home'
                textValue = t(key);
                break;
            case 3:
                key = 'multiple_locations'
                textValue = t(key);
                break;
            default:
                key = 'None'
                textValue = t('not_selected');
                break;
        }

        this.setState({
            location_installed: {
                intValue: e.target.value,
                textValue: textValue,
                key: key,
                error: false,
                helperText: ''
            },
        });
    }

    render() {
        const content =
            <div>
                <Typography variant="title" gutterBottom>
                {t('sign_up_step_2_title')}
                </Typography>
                <Typography variant="subheading" gutterBottom>
                {t('sign_up_step_2_message')}
                </Typography>
                <FormControl style={selectStyle}>
                    <InputLabel htmlFor="age-helper">{t('i_have_installed_the_solution_for')}</InputLabel>
                    <Select
                        required={this.state.location_installed.required}
                        error={this.state.country.error}
                        value={this.state.location_installed.intValue}
                        onChange={e => this.handleSelectChange(e)}
                        input={<Input name="location_installed" id="age-helper" />}>
                        <MenuItem value={0}>{t('not_selected')}</MenuItem>
                        <MenuItem value={1}>{t('primary_home')}</MenuItem>
                        <MenuItem value={2}>{t('secondary_home')}</MenuItem>
                        <MenuItem value={3}>{t('multiple_locations')}</MenuItem>
                    </Select>
                    <FormHelperText>{this.state.location_installed.helperText}</FormHelperText>
                </FormControl>
                <div>
                    <TextField style={firstNameTextStyle}
                        required={this.state.first_name.required}
                        error={this.state.first_name.error}
                        helperText={this.state.first_name.helperText}
                        id="first_name"
                        value={this.state.first_name.value}
                        label={t('first_name')}
                        onChange={this.handleChange('first_name')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.last_name.required}
                        error={this.state.last_name.error}
                        helperText={this.state.last_name.helperText}
                        id="last_name"
                        value={this.state.last_name.value}
                        label={t('last_name')}
                        onChange={this.handleChange('last_name')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.mobile_phone.required}
                        error={this.state.mobile_phone.error}
                        helperText={this.state.mobile_phone.helperText}
                        id="mobile_phone"
                        value={this.state.mobile_phone.value}
                        label={t('mobile_phone_number')}
                        onChange={this.handleChange('mobile_phone')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.address_1.required}
                        error={this.state.address_1.error}
                        helperText={this.state.address_1.helperText}
                        id="address_1"
                        value={this.state.address_1.value}
                        label={t('address_1')}
                        onChange={this.handleChange('address_1')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.address_2.required}
                        error={this.state.address_2.error}
                        helperText={this.state.address_2.helperText}
                        id="address_2"
                        value={this.state.address_2.value}
                        label={t('address_2')}
                        onChange={this.handleChange('address_2')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.postal_code.required}
                        error={this.state.postal_code.error}
                        helperText={this.state.postal_code.helperText}
                        id="postal_code"
                        value={this.state.postal_code.value}
                        label={t('postal_code')}
                        onChange={this.handleChange('postal_code')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.city.required}
                        error={this.state.city.error}
                        helperText={this.state.city.helperText}
                        id="city"
                        value={this.state.city.value}
                        label={t('city')}
                        onChange={this.handleChange('city')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.country.required}
                        error={this.state.country.error}
                        helperText={this.state.country.helperText}
                        id="country"
                        value={this.state.country.value}
                        label={t('country')}
                        onChange={this.handleChange('country')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div>
                    <TextField style={editTextStyle}
                        required={this.state.organization_name.required}
                        error={this.state.organization_name.error}
                        helperText={this.state.organization_name.helperText}
                        id="organization_name"
                        value={this.state.organization_name.value}
                        label={t('organization_name')}
                        onChange={this.handleChange('organization_name')}
                        onKeyPress={e => this.onKeyPressed(e)}
                        margin="normal" />
                </div>
                <div style={buttonContainerStyle}>
                    <Button
                        style={buttonStyle}
                        variant="contained"
                        color="primary"
                        onClick={e => this.onFinishClicked(e)}>
                        {t('finish')}
                    </Button >
                </div>
            </div>

        const narrowContent =
            <div className="Login">
                <Paper className="login-content">
                    <div className="content-container-paper">
                        {content}
                    </div>
                </Paper>
            </div>;

        const normalContent =
            <div className="content-frame">
                <Paper className="content">
                    <div className="content-container-paper">
                        {content}
                    </div>
                </Paper>
            </div>;

        return (
            <div>
                {this.props.comingFromLogin ? narrowContent : normalContent}
            </div>
        );
    }
}

export default SignUpStep2;


// WEBPACK FOOTER //
// ./src/Pages/SignUpStep2.js